import { Box } from "grommet";
import * as React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonWrapper = ({ loading, children }) => {
    if (loading) {
        return (
            <Box pad={"small"} width={{ min: "100px" }}>
                <Skeleton count={1}></Skeleton>
            </Box>
        );
    } else {
        return children;
    }
};

export default SkeletonWrapper;
